var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect } from 'react';
import { Tooltip as ReactToolTip } from 'react-tooltip';
import Styles from './custom-text-styles.scss';
import { CircleSpinner } from '@/presentation/components';
import { wordReplacerState } from './atoms';
import { useRecoilState } from 'recoil';
// Encode HTML entity
function encodeHTML(text) {
    var doc = new DOMParser().parseFromString(text, 'text/html');
    return new XMLSerializer().serializeToString(doc.body);
}
// Decode HTML entity
function decodeHTML(text) {
    var doc = new DOMParser().parseFromString('<!doctype html><body>' + text, 'text/html');
    return doc.body.textContent;
}
function validateValidWordOrSentence(input) {
    // Regular expression that matches <, /, or >
    const regex = /[<>\/]/;
    // Check if the string contains any of the forbidden characters
    const containsForbiddenCharacter = regex.test(input);
    // Return true if it does not contain any forbidden characters, otherwise false
    return !containsForbiddenCharacter;
}
function isContainedInInsTags(htmlText, wordOrPhrase) {
    // Regular expression to find <ins> tags and their content
    const regex = /<ins>(.*?)<\/ins>/g;
    // Get all matches of <ins> tags and their content
    const matches = htmlText.match(regex);
    if (matches) {
        // Check if the word or phrase is contained in any <ins> tag content
        for (const match of matches) {
            if (match.includes(wordOrPhrase)) {
                return true;
            }
        }
    }
    return false;
}
const hasValidKeyword = (wordsToReplace, word) => {
    if (wordsToReplace.includes(word))
        return true;
    return wordsToReplace.includes(decodeHTML(word));
};
const findDefinition = (definitions, wordsToReplace, word) => {
    const basicSearch = definitions === null || definitions === void 0 ? void 0 : definitions[wordsToReplace.indexOf(word)];
    if (basicSearch)
        return basicSearch;
    return definitions === null || definitions === void 0 ? void 0 : definitions[wordsToReplace.indexOf(decodeHTML(word))];
};
const WordReplacerV2 = ({ input, wordsToReplace: wordsToReplaceParam, definitions }) => {
    const usedKeywords = [];
    // to lower case all words
    const wordsToReplace = wordsToReplaceParam.map(word => word.toLowerCase());
    const replaceWords = (text) => {
        const wordsRegex = /<ins>(.*?)<\/ins>/gi;
        const words = text.split(wordsRegex);
        return words.map((wordParam, index) => {
            const word = wordParam === null || wordParam === void 0 ? void 0 : wordParam.toLowerCase();
            if (hasValidKeyword(wordsToReplace, word)) {
                usedKeywords.push(word);
                if (word !== decodeHTML(word))
                    usedKeywords.push(decodeHTML(word));
                return {
                    word,
                    definition: findDefinition(definitions, wordsToReplace, word),
                    wordParam
                };
            }
            return { word, wordParam };
        });
    };
    const highlightedText = replaceWords(input)
        .map((word, index, array) => {
        // console.log('index', index, word, isContainedInInsTags(input, word?.wordParam));
        var _a;
        if (isContainedInInsTags(input, word === null || word === void 0 ? void 0 : word.wordParam)) {
            if (word.definition) {
                return `<span data-tooltip-id="${(_a = word.word) === null || _a === void 0 ? void 0 : _a.toLowerCase()}" data-tooltip-content="${word.definition.replace(/<[^>]+>/g, '')}">${word.wordParam}</span>`;
            }
            // validate it is a valid word or sentence
            if (validateValidWordOrSentence(word.word)) {
                return `<span style="text-decoration:underline;">${word.word}</span>`;
            }
        }
        return word.wordParam;
    })
        .join('');
    return (React.createElement(React.Fragment, null,
        input && React.createElement("div", { dangerouslySetInnerHTML: { __html: highlightedText } }),
        usedKeywords.map((word, index) => (React.createElement(ReactToolTip, { key: `Tooltip-${index}-${word === null || word === void 0 ? void 0 : word.toLowerCase()}`, openOnClick: true, id: word === null || word === void 0 ? void 0 : word.toLowerCase(), className: Styles.strongDescription, style: {
                backgroundColor: '#fff06d',
                color: '#000',
                position: 'absolute',
                top: '1.5625rem',
                left: 0,
                right: 0,
                width: '25rem',
                maxWidth: '25rem',
                overflow: 'hidden',
                padding: '1rem',
                gap: '1.5rem',
                zIndex: 20000,
                borderRadius: '1rem',
                opacity: 1
            } })))));
};
const WordReplacerV2Wrapper = ({ input, loadKeywords }) => {
    const [state, setState] = useRecoilState(wordReplacerState);
    const getKeywords = () => __awaiter(void 0, void 0, void 0, function* () {
        const keywords = yield loadKeywords.all();
        if (keywords) {
            setState(prev => (Object.assign(Object.assign({}, prev), { isLoaded: true, keywords: keywords })));
        }
    });
    useEffect(() => {
        if (!state.isLoaded)
            getKeywords();
    }, []);
    if (state.isLoaded) {
        return (React.createElement(WordReplacerV2, { input: input, wordsToReplace: state.keywords.map(item => item === null || item === void 0 ? void 0 : item.keyword), definitions: state.keywords.map(item => item === null || item === void 0 ? void 0 : item.definition) }));
    }
    return (React.createElement("div", { style: {
            display: 'flex',
            minHeight: '50vh',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            gap: '1rem'
        } },
        React.createElement(CircleSpinner, { size: 40 }),
        React.createElement("span", null, "Loading...")));
};
export default WordReplacerV2Wrapper;
